/**
 * Form Handlers
 *
 * @author Industry at Delete
 * @see    https://github.com/industryatdelete
 */
jQuery(document).ready(function($) {

    /*
     * @TODO
     */
    $('.singleselect').on('click', function(e) {
        //e.preventDefault(); 
    });


    /*
     * @TODO
     */
    $(document).on('click', '.btn-save', function(e) {
        var form = $(this).closest('form');
        var saveButton = form.find('.btn-save');
        var spinner = saveButton.find('.fa-spinner');
        $(form).submit(function(e) {
            if ($(this)[0].checkValidity() === true) {
            } else {
                e.preventDefault();
                e.stopPropagation();
            }
            form.addClass('was-validated');
        });
    });


    /*
     * Ajax Contact Form Handler
     *
     * Bacon ipsum dolor amet tenderloin cow tongue,
     * filet mignon kielbasa brisket salami biltong.
     */
    $(function() {
        
        var form = $('#contact-form');
        var mssg = form.find('.form-messages');
        var bttn = form.find('.btn-send');
        var spin = bttn.find('.fa-spinner');

        $(form).submit(function(e) {
            
            e.preventDefault();
            e.stopPropagation();

            if ($(this)[0].checkValidity() === true) {

                var formData = $(form).serialize();

                $.ajax({
                    type: 'POST',
                    url: SkillsForWales.ajax_url,
                    data: {
                        'action': 'sfw_contact_form_handler',
                        'formdata': formData
                    },
                    beforeSend: function() {
                        $(bttn).prop('disabled', true);
                        $(spin).removeClass('d-none');
                    },
                })
                .done(function(response) {
                    $(bttn).prop('disabled', false);
                    $(spin).addClass('d-none');
                    $(mssg).removeClass('d-none error').addClass('success').text(response);
                    $('.form-control').val('');
                    form.removeClass('was-validated');
                })
                .fail(function(data) {
                    $(bttn).prop('disabled', false);
                    $(spin).addClass('d-none');
                    $(mssg).removeClass('d-none success').addClass('error');
                    if (data.responseText !== '') {
                        $(mssg).text(data.responseText);
                    } else {
                        $(mssg).text('An error occured and your message could not be sent. Please try again.');
                    }
                });
            }
            form.addClass('was-validated');
        });
    });
});